import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { foil_swap_address } from "../../libs/address";
import { getTransactionByHash, getGaugeIdFromPool } from "../../libs/aptos_sdk";
import {
  get_coin_icon,
  get_coin_short_name,
  get_lp_coin_balance,
  getIntAmountFromDecimals,
  gauge_deposit,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import { end_loading, start_loading } from "../../store/loading";
import { sleep } from "../../utils/common";
import Button from "../Common/Button";
import Input from "../Common/Input";
import SelectNftBox from "../Common/SelectNftBox";
import TransactionDialog from "../Common/TransactionDialog";

type Props = {
  coinX: string;
  coinY: string;
};

export default function StakeTab(props: Props) {
  const dispatch = useDispatch();
  const { coinX, coinY } = props;
  const accountAddresses = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );
  const { signAndSubmitTransaction } = useWallet();
  const coinInfoIconX = get_coin_icon(coinX);
  const coinInfoIconY = get_coin_icon(coinY);
  const [stakeText, setStakeText] = useState("Enter an amount");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [step, setStep] = useState(0);
  const [txn, setTxn] = useState("");

  const [amount, setAmount] = useState("");
  const [balanceXY, setBalanceXY] = useState("0");
  const [tokenId, setTokenId] = useState<number>(0);

  useMemo(() => {
    dispatch(start_loading());
    const get = async () => {
      const amountXY = await get_lp_coin_balance(
        accountAddresses,
        coinX,
        coinY
      );
      if (Number(amountXY) > 0) {
        // @ts-ignore
        setBalanceXY(Number(amountXY));
      }
      dispatch(end_loading());
    };
    get();
  }, [accountAddresses, coinX, coinY, dispatch]);

  const handleChangeAmountX = (input: any) => {
    const v = input.target.value;
    setAmount(v);
  };

  const handleCloseAlert = () => setOpenAlert(false);
  const handleStake = async () => {
    setOpenAlert(true);
    setTxn("");
    setStep(0);

    const pool = `${foil_swap_address}::swap::LPToken<${coinX}, ${coinY}>`;
    const amount_decimal = getIntAmountFromDecimals(Number(amount), 9);
    const gauge_id = await getGaugeIdFromPool(pool);
    const data = await gauge_deposit(
      signAndSubmitTransaction,
      pool,
      gauge_id,
      amount_decimal,
      tokenId
    );

    setTxn(data.hash);

    setStep(1);
    let transaction;
    while (!transaction) {
      try {
        transaction = await getTransactionByHash(data.hash);
        window.console.info("transaction", transaction);
      } catch (e) {
        await sleep(500);
        window.console.error(e);
      }
    }
    setStep(2);
  };

  useEffect(() => {
    if (Number(amount) <= 0) {
      setStakeText("Enter an amount");
    } else if (amount > balanceXY) {
      setStakeText(`Insufficient  balance`);
    } else {
      setStakeText("Stake");
    }
  }, [amount, balanceXY]);

  return (
    <>
      <div className="p-4">
        <div className="flex flex-col">
          <div className="w-3/5 pb-3">
            <SelectNftBox setTokenId={setTokenId} />
          </div>
          <div className="flex justify-between items-start rounded-xl bg-primary-100 gap-2 p-4">
            <div className="flex flex-col justify-end items-end">
              <Input
                type="number"
                value={amount}
                placeholder="0.00"
                onChange={handleChangeAmountX}
              />
              {/* <p className="text-white">$: --</p> */}
            </div>
            <div className="flex flex-col items-center gap-2">
              <div className="flex items-center gap-2 bg-primary-200 rounded-full p-2">
                <img
                  alt="Coin"
                  className="w-10 h-10"
                  src={coinInfoIconX.icon}
                />
                <img
                  alt="Coin"
                  className="w-10 h-10 -ml-4"
                  src={coinInfoIconY.icon}
                />
                <span className="text-white text-[15px] font-semibold">
                  {get_coin_short_name(coinX)} - {get_coin_short_name(coinY)} LP
                </span>
              </div>
              <div className="text-white text-opacity-50">
                Balance:
                <span className="text-[#2196f3] ml-3">
                  {Number(balanceXY).toFixed(3)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <Button
          fullWidth
          onClick={handleStake}
          disabled={stakeText !== "Stake"}
          variant="contained"
        >
          {stakeText}
        </Button>
      </div>

      <div>
        <TransactionDialog
          openAlert={openAlert}
          txn={txn}
          title=""
          step={step}
          handleCloseAlert={handleCloseAlert}
        />
      </div>
    </>
  );
}
